import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sso-callback" }

import { useRouter } from 'vue-router'
import { setAuthToken } from '@/utils/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'SsoCallback',
  setup(__props) {

const router = useRouter()

// 백엔드가 토큰/에러를 URL fragment(#)로 전달한다.
const raw = (window.location.hash || '').replace(/^#/, '')
const params = new URLSearchParams(raw)

const ssoError = params.get('ssoError')
if (ssoError) {
  // LoginPage가 에러를 표시하도록 query로 전달
  router.replace({ name: 'Login', query: { ssoError } })
} else {
  const accessToken = params.get('accessToken')
  const refreshToken = params.get('refreshToken')
  if (accessToken) {
    setAuthToken({ accessToken, refreshToken })
    router.replace({ name: 'Board' })
  } else {
    router.replace({ name: 'Login' })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, " 로그인 처리 중... "))
}
}

})